import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { UpdateInvestigationStatusCommand } from './update-investigation-status.command';

@Injectable({ providedIn: 'root' })
export class UpdateInvestigationStatusUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(command: UpdateInvestigationStatusCommand): Observable<void> {
    this._state.setSavingStatus(true);

    return this._repository.updateStatus(command.investigationId, command.statusId).pipe(
      tap(() => {
        this._state.setSavingStatus(false);
      }),
      catchError((error) => {
        this._state.setSavingStatus(false);
        return throwError(() => error);
      }),
    );
  }
}
